import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsSalesByDeviceOsQuery } from "../graphql/queries";
import type {
  AnalyticsSalesByDeviceOsQueryType,
  AnalyticsSalesByDeviceOsQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsSalesByDeviceOsQuery = (
  options?: QueryHookOptions<
    AnalyticsSalesByDeviceOsQueryType,
    AnalyticsSalesByDeviceOsQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsSalesByDeviceOsQueryType,
    AnalyticsSalesByDeviceOsQueryVariablesType
  >(AnalyticsSalesByDeviceOsQuery, options);
};
